// 任务规划相关请求
import req from './index'

//获取任务规划
export const GetTaskList = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.MissionPlanningList_Get', params)
}

//编辑任务规划
export const SaveTask = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.MissionPlanning_Edit', params)
}

//删除任务规划
export const DelTask = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.MissionPlanning_Del', params)
}

//获取机场
export const getAirport = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.GetDockInfo', params)
}


